import React from 'react';

// Multibrand-UI Components
import ContentBox3 from '@zg-rentals/multibrand-ui/lib/ContentBox3';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import './style.scss';

const ActionMessageBox = ({
    children,
    logoType = 'buildings',
} = {}) => (
    <ContentBox3 className="ActionMessageBox">
        <div className="ActionMessageBox-icon-container">
            <div className={`ActionMessageBox-icon ActionMessageBox-${logoType}-icon`} />
        </div>

        <div className="ActionMessageBox-content">
            <Text type="body">
                { children }
            </Text>
        </div>

    </ContentBox3>
);

export default ActionMessageBox;
